import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { GetProfileById } from './get-profile-by-id.thunk';

interface UploadPracticeProfileImageRequest {
    profileId: string;
    practiceProfileId: string;
    files: File[];
}

export const UploadPracticeProfileImage = createAsyncThunk(
    'profilesData/uploadPracticeProfileImage',
    async (request: UploadPracticeProfileImageRequest, { getState, dispatch }: any) => {
        const axios = getState().core.axios;
        const { profileId, practiceProfileId, files } = request;

        const formData = new FormData();
        files.forEach((file) => {
            formData.append('files', file);
        });

        const response = await axios.post(
            `api/ProfilesData/PracticeProfileUploads/${profileId}/${practiceProfileId}`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
        
        if (response.status !== 200) {
            createNotification(response.response?.data?.detail, 'error');
        }
        await dispatch(GetProfileById(profileId));
    }
);
